import { Grid } from "@mui/material";
import { FC } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";
import { H4 } from "../../components/Typography";
import { load, remove } from "../../constants/storage";

const PaymentComplete: FC = () => {
  let navigate = useNavigate();
  let userDetail: any = load("userData");
  let userDetails = JSON.parse(userDetail);
  console.log("----useuserData", userDetails);
  if (userDetails?.mode === "Assisted") {
    setTimeout(() => {
      navigate("/assistedPaymentCompete");
    }, 5000);
  } else {
    setTimeout(() => {
      navigate("/transaction", {
        state: {
          type: "mutualFund",
        },
      });
    }, 5000);
  }

  return (
    <Grid
      height="100vh"
      display="flex"
      flexDirection="column"
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <CircularProgress />
      <H4 sx={{ mt: 2 }}>We are processing your payment</H4>
      <H4>Please wait</H4>
    </Grid>
  );
};

export default PaymentComplete;
